import { isMedium, isXLarge } from '../../../utils/breakpoints';

export default function showProfileAdInContentArea(breakpoint) {
  return isMedium(breakpoint) && !isXLarge(breakpoint);
}
